<div class="header">
  <!-- Desktop screen -->
  <ng-container>
    <img class="header__logo" (click)="goToRoute('programs')" [src]="logoUrl" />

    <div class="header__menu-list">
      <div
        [ngClass]="{ 'header__menu-item--active': item.selected }"
        (click)="selectMenu(item)"
        *ngFor="let item of menuItems"
        class="header__menu-item"
      >
        <i class="{{ item.iconClass }} header__menu-icon"></i>
        <span class="header__menu-title">{{ item.keyTitle | translate }}</span>
      </div>
    </div>

    <div class="header__right-actions">
      <button [matMenuTriggerFor]="languageMenu" class="btn btn--sm btn--no-bg">
        <i class="fa-solid fa-globe"></i>
        <span> {{ 'SETTINGS.PREFERENCES.ITEM.LANGUAGE' | translate }} </span>
      </button>
      <app-profile-avatar
        [profileId]="profile?.id"
        [matMenuTriggerFor]="profileWidget"
      ></app-profile-avatar>
    </div>
  </ng-container>

  <mat-menu #profileWidget="matMenu">
    <app-profile-widget></app-profile-widget>
  </mat-menu>

  <mat-menu #languageMenu="matMenu">
    <button
      mat-menu-item
      *ngFor="let language of languages"
      (click)="changeLanguage(language.language)"
    >
      <span>{{ language.name | translate }}</span>
    </button>
  </mat-menu>
</div>
